import React from 'react';

const HomeDir2 = props => {
  return (
      <div></div>
  )
}

export default HomeDir2